<template>
  <div class="px-4 py-4">
    <nav class="flex justify-center w-full" aria-label="Progress">
      <ol role="list" class="w-full space-y-2">
        <template v-for="step in stepsToDisplay">
          <li
            v-if="step && step.action_by == artist_id"
            class="cursor-default select-none"
            :key="step.id"
          >
            <div class="cursor-default group popover-container">
              <span
                style="width: fit-content;"
                class="flex items-center popover-trigger"
                v-popover="{ name: step.id, event: 'hover' }"
              >
                <span
                  class="relative flex items-center justify-center flex-shrink-0 w-5 h-5 text-nvoko"
                >
                  <Icon :name="step.icon" />
                </span>
                <span class="ml-2 text-sm font-medium text-gray-900">
                  {{ step.description }}
                </span>
              </span>

              <!-- eslint-disable -->
              <popover
                v-bind:name="step.id"
                v-bind:event="'hover'"
                class="step-popover"
              >
                <!-- eslint-enable -->
                <div class="popover-content">
                  <span class="font-bold text-nvoko">
                    {{ step.created_at | date }}
                  </span>
                </div>
              </popover>
            </div>
          </li>
        </template>
      </ol>
    </nav>
  </div>
</template>

<script>
import Icon from "./Icon.vue";

export default {
  components: {
    Icon
  },
  props: {
    history: Array,
    artist_id: String
  },
  filters: {
    date(timestamp) {
      return new Date(timestamp).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric"
      });
    }
  },

  methods: {
    // Removed unused action method
  },
  computed: {
    stepsToDisplay() {
      console.log(this.history);
      return [
        this.history.filter(step => step.action_by === this.artist_id).pop()
      ];
    }
  }
};
</script>

<style>
.vue-popover {
  width: fit-content !important;
  position: absolute !important;
  z-index: 10 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  background-color: white !important;
  border: none !important;
  overflow: visible !important;
}

/* Hide the default popover arrow */
.vue-popover:before,
.vue-popover:after {
  display: none !important;
}

.popover-container {
  position: relative;
}

.popover-trigger {
  position: relative;
}

.step-popover {
  top: -12px !important;
  left: 10px !important;
  transform: translateY(-100%) !important;
  animation: fadeIn 0.2s ease-in-out !important;
}

.popover-content {
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  min-width: 200px;
  position: relative;
  color: #333;
  border-radius: 8px;
}

.popover-content:after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 12px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid white;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.05));
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-90%);
  }
  to {
    opacity: 1;
    transform: translateY(-100%);
  }
}
</style>
